import {SalesDashboardRepository} from './SalesDashboardRepository';
import {SalesDashboardAPIDataSource, InvoiceDTO, AgingBucketDTO, InvoiceFiltersDTO, InvoiceAttachmentDTO} from '../api/SalesDashboardAPIDataSource';
import type {BaseResponse} from '../../../Data/types/BaseResponse';

export class SalesDashboardRepositoryImpl implements SalesDashboardRepository {
  async getInvoices (params: InvoiceFiltersDTO): Promise<BaseResponse<InvoiceDTO[]>> {
    const data = await SalesDashboardAPIDataSource.getInvoices(params);
    return {
      stat_code: 200,
      stat_message: 'success',
      data
    };
  }

  async updateInvoiceStatus (invoiceId: number | string, status: string): Promise<BaseResponse<unknown>> {
    const data = await SalesDashboardAPIDataSource.updateInvoiceStatus(invoiceId, status);
    return {
      stat_code: 200,
      stat_message: 'success',
      data
    };
  }

  async recordPayment (payload: {invoice_id: number; amount: number; payment_method: string; notes?: string}): Promise<BaseResponse<unknown>> {
    const data = await SalesDashboardAPIDataSource.recordPayment(payload);
    return {
      stat_code: 200,
      stat_message: 'success',
      data
    };
  }

  async getPendingBankTransfers (params: {page?: number; limit?: number}): Promise<BaseResponse<any[]>> {
    const data = await SalesDashboardAPIDataSource.getPendingBankTransfers(params);
    return {
      stat_code: 200,
      stat_message: 'success',
      data
    };
  }

  async reviewBankTransfer (payload: {invoice_id: number; action: 'approved'|'rejected'; notes?: string}): Promise<BaseResponse<unknown>> {
    const data = await SalesDashboardAPIDataSource.reviewBankTransfer(payload);
    return {
      stat_code: 200,
      stat_message: 'success',
      data
    };
  }

  async getAgingReport (params: {storeId?: number; dateFrom?: string; dateTo?: string}): Promise<BaseResponse<AgingBucketDTO>> {
    const data = await SalesDashboardAPIDataSource.getAgingReport(params);
    return {
      stat_code: 200,
      stat_message: 'success',
      data
    };
  }

  async getInvoiceAttachment (invoiceId: string | number): Promise<InvoiceAttachmentDTO | null> {
    return await SalesDashboardAPIDataSource.getInvoiceAttachment(invoiceId);
  }

  async uploadInvoiceAttachment (invoiceId: string | number, file: File): Promise<InvoiceAttachmentDTO> {
    return await SalesDashboardAPIDataSource.uploadInvoiceAttachment(invoiceId, file);
  }

  async replaceInvoiceAttachment (invoiceId: string | number, file: File): Promise<InvoiceAttachmentDTO> {
    return await SalesDashboardAPIDataSource.replaceInvoiceAttachment(invoiceId, file);
  }

  async deleteInvoiceAttachment (invoiceId: string | number): Promise<void> {
    return await SalesDashboardAPIDataSource.deleteInvoiceAttachment(invoiceId);
  }
}
